var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"now-showing mb-5"},[_c('h3',{staticClass:"mb-4"},[_vm._v("Now Showing")]),_c('InfoBox',{attrs:{"id":_vm.id,"routeToDetail":_vm.routeToDetail,"img":_vm.img,"title":_vm.title,"subtitle":_vm.subtitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }